<template>
	<div id="NoticeRule">
		<div class="ops_title">运维大屏</div>
		<div class="dev_org">
			<organize @setOrId="setOrId(arguments)" :recoveryName="recoveryName" @setTree="getTree"></organize>
			<!--<organize @setOrId="setOrId" :recoveryName="recoveryName" @setTree="getTree"></organize>-->
		</div>
		<!-- 列表 -->
		<div class="list-box" style="top: 37px;">
			<div class="bg">
				<div class="list-top clearfix">
					<el-button :disabled="functionSet.includes('bigScreenEdit')&&!isLook?null:'disabled'" type="primary" class="add-btn" id="addScreen" @click="add()">新建大屏</el-button>
					<div class="type-box f-r">
            <div class="card-btn" :class="{'active1':listType==1}" @click="listType=1"></div>
            <div class="table-btn" :class="{'active2':listType==2}" @click="listType=2"></div>
          </div>

          <div class="search-btn">
						<el-button type="primary" class="add-btn" @click="search" id="searchBtnScreen">搜索</el-button>
					</div>
					<div class="search">
						<el-input placeholder="请输入大屏名称" v-model="searchVal" class="search-input" id="searchRuleVal" @keyup.enter.native="search">
							<i slot="suffix" class="el-input__icon el-icon-search"></i>
						</el-input>
					</div>
				</div>
				<div class="company-list clearfix" v-show="listType==1">
					<div class="box clearfix" v-for="(item,index) in dataList" v-if="item.type == state || state == 0">
						<div class="box_shot" :class="{'unpointer': item.type == 1 && orSuperior.type != 3}" @click="preview(item)" :style="{'background-image': 'url('+ImageBaseUrl+item.screenshot+')'}">
							<div class="show_shot">
								<!-- <div>通</div> -->
                <img :src="pc" v-if="item.homepageType==1">
                <img :src="sj" v-if="item.homepageType==2">
							</div>
						</div>
						<div class="box_title clearfix">
							{{item.name}}
							<div class="screen _del" :class="functionSetjudge(item)" @click="del(item,$event)">删除</div>
							<div class="screen _edit" :class="functionSetjudge(item)" @click="edit(item,$event)">编辑</div>
						</div>
					</div>

				</div>

				<div class="company-list clearfix" v-show="listType==2" style="height: 590px; max-height: 590px;">
				    <ul class="list-title">
				        <li style="margin-left: 3%;">大屏名称</li>
				        <li class="w-90 min-44">分组</li>
				        <li class="w-120 min-44">设为企业首页</li>
				        <li class="w-90 min-44">主页类型</li>
				        <li>版本</li>
				        <li class="w-26 min-120">操作</li>
				    </ul>
				    <div class="scroll">
				        <ul class="list-details" v-for="(item,i) in dataList" :key="i" v-show="dataList.length!=0">
				            <li style="margin-left: 3%;" :title="item.name">{{item.name}}</li>
				            <li class="w-90 min-44" :title="item.groupName">{{item.groupName}}</li>
				            <li class="w-120 min-44">{{item.companyName}}</li>
				            <li class="w-90 min-44">{{item.homepageType==1?"WEB端":"小程序端"}}</li>
				            <li>{{changeTime(item.version)}}</li>
				            <li class="operate w-26 min-120">
				                <span :class="functionSetjudge(item)" @click="preview(item)">打开</span>
				                <span :class="functionSetjudge(item)" @click="edit(item,$event)":id="`editUser${i}`">编辑</span>
				                <span :class="functionSetjudge(item)" @click="del(item,$event)" :id="`delUser${i}`">删除</span>
				            </li>
				        </ul>
				    </div>
				</div>
				<!-- 没有列表数据 -->
				<div class="nullDataBox" v-show="dataList.length==0">
					<img :src="nullData" class="nullData">
					<span>什么东西都没有找到...</span>
				</div>
			</div>
			<!-- 分页 -->
			<div class="bottom_page"><Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber"></Pagination></div>
			<!-- 弹窗 -->
			<div class="popup">
				<!-- 删除通知规则 -->
				<div class="popup-delAlarm" ref="del">
					<div class="popup-title">
						删除大屏<i class="el-icon-circle-close close" @click="close()" id="closeDel1"></i>
					</div>
					<div class="popup-lab t-left">
						系统将删除该大屏,是否继续？
						<p class="popup-btn-box">
							<el-button type="primary" @click="delTrue()" id="delRule">确定</el-button>
							<el-button @click="close()" id="closeDel2">取消</el-button>
						</p>
					</div>
				</div>

        <div class="popup-add" v-show="addShow">
        	<div class="popup-title">
        		新建大屏<i class="el-icon-circle-close close" @click="close('addShow')" id="closeDel1"></i>
        	</div>
        	<div class="popup-lab t-left">
            <el-form :rules="rules" ref="addForm" class="clearfix" :model="ruleForm" :disabled="!functionSet.includes('bigScreenEdit')">
              <div class="popup-left">
                <el-form-item prop="name" label="大屏名称：" autocomplete="off" >
                    <i><img :src="notes" title="大屏名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                    <el-input v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item label="所属组织：" prop="group" autocomplete="off" class="m-t-0">
                    <div class="popup-lab m-t-0" @mouseleave="selectShow=false" v-show="functionSet.includes('bigScreenEdit')">
                        <div class="or-Superior" @click='showSelect'>
                            <span class="p-a-l-10">{{orSuperior.name}}</span>
                            <i><img :src="down" @click="showSelect"></i>
                            <div class="select-box tree" ref="selectbox" v-show='selectShow'>
                                <div class="dashed">
                                    <el-tree :data="orSuperiorData" :indent='0' node-key="id" :highlight-current="true" :default-expand-all="true" :check-on-click-node="false" @node-click="selectId" :props="defaultProps">
                                        <span class="custom-tree-node" slot-scope="{ node, data }">
                                            <i><img :src="data.type == 1 ? branch : data.type == 2 ? location : area" class="tree-icon"></i>
                                            <span>{{ node.label }}<span v-if='data.roleName&&data.type!=3'>({{data.roleName}})</span></span>
                                        </span>
                                    </el-tree>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="popup-lab m-t-0" v-show="!functionSet.includes('bigScreenEdit')">
                        <div class="or-Superior disabled3">
                            <span class="p-a-l-10">{{orSuperior.name}}</span>
                            <i><img :src="down"></i>
                        </div>
                    </div>
                </el-form-item>
              </div>
              <div class="popup-right">
                <el-form-item label="设为企业首页：" autocomplete="off">
                    <el-select v-model="ruleForm.homepage" placeholder="请选择" style="width:100%;margin-top:5px;" clearable>
                        <el-option
                        v-for="item in companyList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="首页类型：" prop="homepageType" autocomplete="off" >
                    <el-select v-model="ruleForm.homepageType" placeholder="请选择" style="width:100%;">
                        <el-option label="WEB端" :value="1"></el-option>
                        <el-option label="小程序端" :value="2"></el-option>
                    </el-select>
                </el-form-item>
              </div>
              <div class="popup-bottom">
                <el-form-item :label="'版本：'+changeTime(ruleForm.version)" autocomplete="off" ></el-form-item>
                <el-form-item label="大屏缩略图：" autocomplete="off">
                  <img :src="ruleForm.screenshot" style="margin-top:10px;max-width: 316px;max-height: 178px;">
                  <!-- <el-button type="text" class="f-r" @click="toEdit">进入编辑器</el-button> -->
                </el-form-item>
              </div>
            </el-form>
        	</div>
        		<p class="popup-btn-box">
        			<el-button type="primary" @click="createScreen">确定</el-button>
        			<el-button @click="close('addShow')">取消</el-button>
        		</p>
        </div>
        <div class="popup-add" v-show="editShow">
        	<div class="popup-title">
        		编辑大屏<i class="el-icon-circle-close close" @click="close('editShow')"></i>
        	</div>
        	<div class="popup-lab t-left">
            <el-form :rules="rules" ref="updateForm" class="clearfix" :model="ruleForm" :disabled="!functionSet.includes('bigScreenEdit')">
              <div class="popup-left">
                <el-form-item prop="name" label="大屏名称：" autocomplete="off" >
                    <i><img :src="notes" title="大屏名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                    <el-input v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item label="所属组织：" prop="group" autocomplete="off" class="m-t-0">
                    <div class="popup-lab m-t-0" @mouseleave="selectShow=false" v-show="functionSet.includes('bigScreenEdit')">
                        <div class="or-Superior" @click='showSelect'>
                            <span class="p-a-l-10">{{orSuperior.name}}</span>
                            <i><img :src="down" @click="showSelect"></i>
                            <div class="select-box tree" ref="selectbox" v-show='selectShow'>
                                <div class="dashed">
                                    <el-tree :data="orSuperiorData" :indent='0' node-key="id" :highlight-current="true" :default-expand-all="true" :check-on-click-node="false" @node-click="selectId" :props="defaultProps">
                                        <span class="custom-tree-node" slot-scope="{ node, data }">
                                            <i><img :src="data.type == 1 ? branch : data.type == 2 ? location : area" class="tree-icon"></i>
                                            <span>{{ node.label }}<span v-if='data.roleName&&data.type!=3'>({{data.roleName}})</span></span>
                                        </span>
                                    </el-tree>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="popup-lab m-t-0" v-show="!functionSet.includes('bigScreenEdit')">
                        <div class="or-Superior disabled3">
                            <span class="p-a-l-10">{{orSuperior.name}}</span>
                            <i><img :src="down"></i>
                        </div>
                    </div>
                </el-form-item>
              </div>
              <div class="popup-right">
                <el-form-item label="设为企业首页：" autocomplete="off">
                    <el-select v-model="ruleForm.homepage" placeholder="请选择" style="width:100%;margin-top:5px;" clearable>
                        <el-option
                        v-for="item in companyList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="首页类型：" prop="homepageType" autocomplete="off" >
                    <el-select v-model="ruleForm.homepageType" placeholder="请选择" style="width:100%;">
                        <el-option label="WEB端" :value="1"></el-option>
                        <el-option label="小程序端" :value="2"></el-option>
                    </el-select>
                </el-form-item>
              </div>
              <div class="popup-bottom">
                <el-form-item :label="'版本：'+changeTime(ruleForm.version)" autocomplete="off" ></el-form-item>
                <el-form-item label="大屏缩略图：" autocomplete="off">
                  <img :src="ruleForm.screenshot" style="margin-top:10px;max-width: 316px;max-height: 178px;">
                  <el-button type="text" class="f-r" @click="toEdit" :disabled="isLook||!functionSet.includes('bigScreenEdit')">进入编辑器</el-button>
                </el-form-item>
              </div>
            </el-form>
        	</div>
        		<p class="popup-btn-box">
        			<el-button type="primary" @click="updateScreen">确定</el-button>
        			<el-button @click="close('editShow')">取消</el-button>
        		</p>
        </div>

			</div>
		</div>
		<div class="popupT">
			<!-- 验证码授权 -->
			<div class="popupT-clear" v-show='functionShow' id="privilege" style="position: fixed; height: 349px;text-align: left;margin-left: -216px">
				<div class="popupT-title">
					获取验证码授权<i><img :src="notes" title="提示" style="position: relative; left: 5px; top: 3px;"></i><i class="el-icon-circle-close close" @click="closeT('functionShow')" id="closeClear3"></i>
				</div>
				<div class="popupT-lab">
					手机号：
					<el-input disabled v-model="phone">{{phone}}</el-input>
				</div>
				<div class="popupT-lab clearfix">
					<p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
					<el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode" @submit.native.prevent>
						<el-form-item prop="verifyCode">
							<el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" @keyup.enter.native="Privilege" v-model='verifyForm.verifyCode' maxlength="4" @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
						</el-form-item>
					</el-form>
					<div class="code-box">
						<p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
						<p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
					</div>
				</div>
				<div class="popupT-lab">
					<p class="btn-box" style="margin-top: 26px;text-align: center;">
						<el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
						<el-button @click="closeT('functionShow')" id="closeClear4">取消</el-button>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Pagination from "@/components/PublicAssembly/pagination"
	import Organize from "@/components/PublicAssembly/organize"
  import { JSONStringify,JSONParse,zip } from "@/pages/config/functions.js"
	import { mapState } from 'vuex';
	export default {
		data() {
      var valiName = (rule, value, callback) =>{      //报表名称
          value = this.ruleForm.name
          // let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
          if(value == "" ||value==null){
              callback(new Error('请输入大屏名称'));
          }else if(value.length>32){
              callback(new Error('大屏名称由1~32个字符构成'));
          }else{
              callback();
          }
      }
			return {
				nullData: require('@/assets/image/index/nullData.png'),
				imgA: require('@/assets/image/devops/testBg.png'),
				pc: require('@/assets/image/screen/diannao.png'),
				sj: require('@/assets/image/screen/shouji.png'),
        area:require('@/assets/image/company/qyzu.png'),
        branch:require('@/assets/image/company/ptzu.png'),
        location:require('@/assets/image/company/jczu.png'),
        down:require('@/assets/image/organize/down.png'),
        listType:1,
				roleTree: [], //存放组织树
				roleId: '', //当前选中的分组的角色id
				orCode: '', //当前分组id
				orSuperior: {}, //存放当前选中分组的所有信息
				orSuperiorData: [], //存放当前选中分组的整棵树 用于Options
				functionSet: [], //存放当前权限列表
				recoveryName: '', //是否显示企业回收站
				totalCount: 1, //总记录数
				pageSize: 10, //当前页数显示数据量
				pageNumber: 1, //当前页数
				dataList: [], //存放当前大屏列表
        companyList:[],
				searchVal: "", //搜索input值
				state: 0, //当前显示的列表类型
				delRuleShow: false, //删除弹窗开关

				delId: null, //当前点击删除的id
        selectShow:false,
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        addShow:false,
        editShow:false,
        ruleForm:{
          name:'',
          homepage:null,
          homepageType:1,
          screenshot:require('../../assets/image/devops/mould/mould3.png'),
          version:new Date().getTime(),
        },
				rules: {
					verifyCode: [{
						message: '请输入验证码',
						required: true,
						trigger: 'blur'
					}],
          name:[{validator: valiName, required: true, trigger: 'blur'}],
          homepageType:{required: true,message: '请选择首页类型',trigger: 'change'}
				},
				notes:require('@/assets/image/organize/notes.png'),
				verifyForm: {
					verifyCode: '',
				},
				functionShow: false,
				VerifyArr: [],
				verifyCode: '',
				second: 60,
				getCodeShow: true,
				countdownShow: false,
				phone: '',
				time: null,
			}
		},
		computed: {
			...mapState("defaultImgOptions", {
				ImageBaseUrl: 'ImageBaseUrl',
			}),
			isLook() {
				return this.$store.state.isLook;
			},
		},
		components: {
			Pagination,
			Organize
		},
		created() {
			this.$store.state.activeIndex='/Devops'
		},
		mounted() {
//			this.getTree('first');
			this.phone = this.hidePhone(this.$store.state.userData.mobile);
			this.getData();
		},
		methods: {
      toEdit(){
        let state = JSON.stringify(this.$store.state)
        localStorage.setItem("store", state)
        let screenData=this.clone(this.ruleForm)
        screenData.context = ""
        localStorage.setItem('screenData',zip(JSON.stringify(screenData)))
        // return
        this.windowOpen('/Editor',null,null,'编辑大屏 - '+screenData.name)
        if(this.ruleForm.groupCode.slice(0,1) == "E"){
          localStorage.setItem("companyName",this.orSuperior.name)
        }
      },
      createScreen(){
        this.$refs.addForm.validate((valid)=>{
          if(valid){
            let data = this.clone(this.ruleForm)
            data.groupCode = this.orSuperior.code
            data.groupName = this.orSuperior.name
            this.postNoJson('/Screen/create',data).then(res=>{
              if(res.success){
                this.close('addShow')
                this.search()
              }else{
                this.$message({
                	message: `新建大屏失败：${res.message}`,
                	type: 'warning'
                });
              }
            })
          }
        })
      },
      updateScreen(){
        this.$refs.updateForm.validate((valid)=>{
          if(valid){
            let data = this.clone(this.ruleForm)
            data.groupCode = this.orSuperior.code
            data.groupName = this.orSuperior.name
            this.postNoJson('/Screen/update',data).then(res=>{
              if(res.success){
                this.close('editShow')
                this.search()
              }else{
                this.$message({
                	message: `编辑大屏失败：${res.message}`,
                	type: 'warning'
                });
              }
            })
          }
        })
      },
			/*验证码*/
			// 获取验证码
			getCode() {
				this.get('/UserProfile/sendVerifyCode').then((res) => {
					if(res.success) {
						this.getCodeShow = false
						this.countdownShow = true
						const TIME_COUNT = 60;
						this.$message({
							message: '验证码发送成功',
							type: 'success'
						});
						if(!this.timer) {
							this.second = TIME_COUNT;
							this.show = false;
							this.timer = setInterval(() => {
								if(this.second > 0 && this.second <= TIME_COUNT) {
									this.second--;
								} else {
									this.getCodeShow = true;
									this.countdownShow = false;
									clearInterval(this.timer);
									this.timer = null;
								}
							}, 1000)
						}
					} else {
						this.$message({
							message: `验证码发送失败：${res.message}`,
							type: 'warning'
						});
					}
				})
			},
			// 用户提权
			Privilege() {
				this.$refs.verifyCode.validate((valid) => {
					if(valid) {
						this.post('/UserProfile/privilege', {
							verifyCode: this.verifyForm.verifyCode
						}).then(res => {
							if(res.success) {
								this.$message({
									message: '提权成功',
									type: 'success'
								})
								this.VerifyArr.splice(this.VerifyArr.indexOf(5), 1)
								localStorage.setItem('verifyCodeModule', this.VerifyArr)
								this.$store.state.mask = false
								this.functionShow = false
								this.getCodeShow = true;
								this.countdownShow = false;
								clearInterval(this.timer);
								this.timer = null;
								this.verifyForm.verifyCode = ''
							} else {
								this.$message({
									message: `提权失败：${res.message}`,
									type: 'warning'
								})
							}
						})
					}
				})
			},
			closeT() {
				this.functionShow = false;
				this.$store.state.mask = false;
				this.verifyForm.verifyCode = ''
			},
			//获取系统配置
			getData() {
				this.VerifyArr = localStorage.getItem('verifyCodeModule').split(',').map(Number)
			},


			/*权限判断*/
			functionSetjudge(item){
        if(!this.functionSet.includes('bigScreenEdit') || this.isLook){
          return 'noset'
        }
      },
			/*预览*/
			preview(obj) {
				// let self = this;
				// if(obj.type == 1){
				// 	/*如果为通用大屏 则判断当前选择分组是否为企业*/
				// 	if(this.orSuperior.type == 3){
				// 		obj.items.push({
				// 			type: 4,
				// 			value: this.orSuperior.id
				// 		})
				// 		obj.groupCode = this.orSuperior.code
				// 		sessionStorage.setItem('screenShow_itemData', JSON.stringify(obj))
				// 		// let routerMyCard = this.$router.resolve({
				// 		// 	path: '/DevopsPreview'
				// 		// })
				// 		// let reg = new RegExp('/dist')
				// 		// routerMyCard.href = routerMyCard.href.replace(reg,"")
				// 		// window.open(routerMyCard.href, '_blank');
				// 		this.windowOpen('/DevopsPreview','screenShow'+this.orSuperior.code+'-'+obj.id)
				// 	}
				// }else{
				// 	/*如果为自定义大屏 则不需要判断当前选择分组是否为企业*/
				// 	sessionStorage.setItem('screenShow_itemData', JSON.stringify(obj))
				// 	// let routerMyCard = this.$router.resolve({
				// 	// 	path: '/DevopsPreview'
				// 	// })
				// 	// let reg = new RegExp('/dist')
				// 	// routerMyCard.href = routerMyCard.href.replace(reg,"")
				// 	// window.open(routerMyCard.href, '_blank');
				// 	this.windowOpen('/DevopsPreview','screenShow'+this.orSuperior.code+'-'+obj.id)
				// }

        // let content = JSONParse(obj.context)
        // if(obj.homepage){
        //   content.companyId = obj.homepage
        // }

        // let content={
        //   viewWidth:this.$store.state.viewWidth,
        //   viewHeight:this.$store.state.viewHeight,
        //   BgColor:this.$store.state.canvasBgColor,
        //   dragList:this.$store.state.DragList,
        //   companyId:obj.homepage,
        // }
        // console.log(obj,content)
        //sessionStorage改为localstorage
        let state = JSON.stringify(this.$store.state)
        localStorage.setItem("store", state)
        // sessionStorage.setItem('screen',JSONStringify(obj))
        // sessionStorage.setItem('content',JSONStringify(content))
        this.windowOpen('/indexPreview','','?type=1&id='+obj.id,'运维大屏 - '+obj.name)

			},
			add() {
				if(this.isLook)return;
				// this.$router.push({
				// 	name: 'DevopsAdd',
				// })
        this.ruleForm = this.$options.data().ruleForm
        this.ruleForm.version = new Date().getTime()
        // this.orSuperior = this.orSuperiorData[0]
        this.$refs.addForm.clearValidate()
        this.getCompany()
        this.addShow = true
        this.$store.state.mask = true
			},
			edit(item,v) {
				if(this.isLook)return;
				if(item.type == 1){
					if(this.VerifyArr.includes(5)){
            this.functionShow=true;
            this.$store.state.mask=true;
            return
					}
				}
        let self = this
        let getTreeType = function(tree,code){
          tree.forEach(e => {
              if (e.code === code) {
                self.orSuperior = e
                if(e.type!=3){
                  self.getCompany(e.id)
                }else{
                  self.companyList = [e]
                }
              }  // 某一项的id 等于 传入的id 就把该数组找出来
              if (e.children&&e.children.length > 0) {
                  getTreeType(e.children, code)
              }
          })
        }
        getTreeType(this.orSuperiorData,item.groupCode)
        this.get('/Screen/get',{id:item.id}).then(res=>{
          // console.log(res)
          if(res.success){
            this.ruleForm = res.result
            this.editShow = true
            this.$store.state.mask=true
          }else{
            this.$message({
            	message: `获取大屏失败：${res.message}`,
            	type: 'warning'
            });
          }
        })
			},
			del(item,v) {
				if(this.isLook)return;
				if(item.type == 1){
					if(this.VerifyArr.includes(5)){
            this.functionShow=true;
            this.$store.state.mask=true;
            return
					}
				}

				if(!v.srcElement.className.split(' ').includes('noset')){
					this.delId = item.id;
					this.$store.state.mask = true;
					this.ChangeDel();
				}
			},
			delTrue() {
				//console.log(this.delId)
				if(this.isLook)return;
				/*删除大屏*/
				this.get('/Screen/remove', {
					id: this.delId, //this.delId
				}).then((res) => {
					if(res.success) {
						this.$message({
							message: `删除大屏成功`,
							type: 'success'
						});
						this.getlist({
							pageNumber: Number(this.pageNumber),
							length: Number(this.pageSize),
							code: this.orCode,
							keyword: this.searchVal,
						});
						this.ChangeDel();
						this.$store.state.mask = false;
						this.delId = null;
					} else {
						this.$message({
							message: `删除大屏失败：${res.message}`,
							type: 'warning'
						});
					}
				})

			},
			// 关闭弹窗
			close(name) {
				this.$store.state.mask = false;
        if(name){
          this[name]=false
        }else{
          this.ChangeDel();
          this.delId = null;
        }
			},
			ChangeDel() {
				let self = this;
				if(this.$refs.del.style.display == "" || this.$refs.del.style.display == "none") {
					this.$refs.del.style.display = "block";
					setTimeout(function() {
						self.$refs.del.style.opacity = 1;
						self.$refs.del.style.top = 0 + 'px';
					}, 50)
				} else {
					this.$refs.del.style.opacity = 0;
					self.$refs.del.style.top = -50 + 'px';
					setTimeout(function() {
						self.$refs.del.style.display = "none";
					}, 100)
				}
			},
			// 获取列表
			getlist(parm) {
        this.pageSize = this.$store.state.userConfig.rowsPerPage;
				parm.length = this.pageSize ;
				parm.type = null;
				this.get('/Screen/query', parm).then((res) => {
					if(res.success) {
						this.totalCount = res.result.totalCount;
						this.dataList = res.result.data
					} else {
						this.$message({
							message: `获取列表数据失败：${res.message}`,
							type: 'warning'
						});
					}
				})
			},
			// 获取组织树
			getTree(type) {
				this.get('/Group/getOrganizationTree').then((res) => {
					if(res.success) {
						this.$store.state.treeData = res.result;                       
						this.$store.state.expandedArr=[]
            this.expanded(this.$store.state.treeData,1)
						this.orSuperior = this.clone(this.$store.state.treeData[0])
            this.orCode=this.orSuperior.code
						this.functionSet = this.$store.state.treeData[0].functionSet.split(',')
						this.orSuperiorData = [] //初始化树
						for(let obj of res.result) {
							if(obj.roleId == this.roleId) { //获取当前角色下树数据
								obj = this.clone(obj)
								this.orSuperiorData.push(obj)
								return
							}
						}
						if(type == 'first') {
							this.roleId = this.$store.state.treeData[0].roleId
							this.pageSize = this.$store.state.userConfig.rowsPerPage;
							sessionStorage.setItem("screenSuperior",JSON.stringify(this.orSuperior))
							this.getlist({
								pageNumber: 1,
								length: Number(this.pageSize),
								code: this.orCode,
								keyword: this.searchVal,
							});
						}
					}
				})
			},
      // 展开上级组
      showSelect(){
          var box = this.$refs.selectbox;
          this.selectShow=true;
      },
      // 获取用户点击的上级组节点
      selectId(data){
          if(this.orSuperior.code==data.code){
              this.selectShow=false;
              return
          }
          this.orSuperior= data;
          // console.log(data)
          this.getCompany()
          this.selectShow=false;
          this.$forceUpdate()
      },
      getCompany(){
        // console.log(this.orSuperior.id)
        this.get('/Company/getList',{id:this.orSuperior.id}).then(res=>{
          if(res.success){
            this.companyList = res.result
          }else{
            this.companyList = []
            this.$message({
            	message: `企业列表数据失败：${res.message}`,
            	type: 'warning'
            });
          }
        })
      },
			// 获取的当前组
			setOrId(node) {
				if(node[0].code != this.orCode) {
					this.roleId = node[0].roleId
					this.orSuperiorData = []
					this.orSuperior = node[0]
					sessionStorage.setItem("screenSuperior",JSON.stringify(this.orSuperior))
					for(let obj of this.$store.state.treeData) {
						if(node[0].roleId == obj.roleId) { //获取当前角色下的树数据
							obj = this.clone(obj)
							this.orSuperiorData.push(obj)
						}
					}
				}
				this.orCode = node[0].code;
				this.functionSet = node[1]
        // console.log(this.orSuperior)
				this.getlist({
					pageNumber: Number(this.pageNumber),
					length: Number(this.pageSize),
					code: this.orCode,
					keyword: this.searchVal,
				});
			},
//sessionStorage改为localStorage
			// 修改分页size
			setSize(pageObj) {
				if(this.isPageSize) {
					this.isPageSize = false;
					return;
				}
				this.pageSize = pageObj.size;
			},
			// 修改页数
			setNum(number) {
//				console.log(number)
				this.pageNumber = number;
				this.getlist({
					pageNumber: Number(this.pageNumber),
					length: Number(this.pageSize),
					code: this.orCode,
					keyword: this.searchVal,
				});
			},
			// 头部标签
			headClick(i) {
//				console.log(this.orCode)
				this.isCount = true
				this.state = i
				let num = 0
				for(let obj of this.dataList){
					if(obj.type == i){
						num+=1
					}
				}
				this.totalCount = num
			},
			//搜索
			search() {
				this.isCount = true
				this.getlist({
					pageNumber: Number(this.pageNumber),
					length: Number(this.pageSize),
					code: this.orCode,
					keyword: this.searchVal,
				});
			},
		},
	}
</script>
<style scoped>
  .or-Superior{
      height: 34px;
      line-height: 34px;
      border-radius: 5px;
      border: 1px solid #e5e5e5;
      padding:0 10px;
      position: relative;
      box-sizing: border-box;
      top:30px;
      margin-bottom:30px;
  }
  .or-Superior i{
      float: right;
  }
  .or-Superior img{
      width: 22px;
      margin-top: 6px;
  }
  .p-a-l-10{
      position: absolute;
      left: 10px;
  }
  .select-box{
      width: 100%;
      position: absolute;
      left: -1px;
      top: 32px;
      border: 1px solid #e5e5e5;
      max-height: 315px;
      overflow: auto;
      /* width: 370px; */
      border-radius: 5px;
      z-index: 99;
      background: #fff;
  }
  .select-box2{
    margin-right: 20px;
    font-size: 14px;
    line-height: 34px;
  }.
  .card-btn:hover{
    background-image: url(../../assets/image/screen/card2.png) !important;
  }
  .type-box .active2{
    background-image: url(../../assets/image/screen/liebiao2.png) !important;
  }
  .table-btn:hover{
    background-image: url(../../assets/image/screen/liebiao2.png) !important;
  }
  .active1{
    background-image: url(../../assets/image/screen/card2.png) !important;
  }
  .card-btn{
    width: 24px;
    height: 24px;
    display: inline-block;
    background-size: 100% 100%;
    margin: 5px 2.5px;
    background-image: url(../../assets/image/screen/card.png);
  }
  .table-btn{
    width: 24px;
    height: 24px;
    display: inline-block;
    background-size: 100% 100%;
    margin: 5px 2.5px;
    background-image: url(../../assets/image/screen/liebiao.png);
  }
	.unpointer{
		cursor: not-allowed !important;
	}
	/*验证码css*/

	.popupT>div {
		position: fixed !important;
		top: 10%;
		left: 50%;
		padding: 0 28px;
		box-sizing: border-box;
		margin-left: -407px;
		width: 578px;
		background-color: #fff;
		z-index: 9999;
		padding-bottom: 30px;
	}

	.popupT-title {
		font-size: 16px;
		line-height: 64px;
		border-bottom: 1px solid #e5e5e5;
		margin-bottom: 22px;
		text-align: left;
	}

	.popupT-lab {
		font-size: 14px;
		line-height: 30px;
		margin-bottom: 14px;
	}

	.btn-box {
		position: relative;
		margin-top: 260px;
	}

	.btn-box2 {
		text-align: center;
		width: 100%;
		margin-top: 46px;
	}

	.btn-box>p {
		margin-top: 10px;
		color: #909090;
	}

	.bottom_page{
	    position: absolute;
	    bottom: 102px;
	    left: 0;
	    right: 0;
	    margin: auto;
	}
	.popup{
	    position: absolute;
	    top: 0;
	    bottom: 155px;
	    left: 92px;
	    margin: auto;
	}
	.noset{
		color: #A0CFFF !important;
		cursor: not-allowed !important;
	}
	._edit {
		margin-right: 21px;
	}

	.screen {
		float: right;
		color: #5088E4;
		cursor: pointer;
	}

	.box_title {
		width: 100%;
		text-indent: 5px;
		color: #414141;
		text-align: left;
		font-size: 13px;
		line-height: 45px;
	}

	.show_shot div {
		transform: rotate(45deg);
	}
  .show_shot img {
  	width: 16px;
    height: 16px;
  }
	.show_shot {
		position: absolute;
    width: 53px;
    height: 44px;
    top: -18px;
    left: -24px;
    background-color: #ffce00;
    color: #fff;
    line-height: 73px;
    text-align: center;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    font-size: 14px;
	}

	.box .box_shot {
		background-position: center;
		background-size: 100% 100%;
		background-repeat: no-repeat;
		overflow: hidden;
		width: 100%;
		height: calc(100% - 54px);
		margin-top: 9px;
		float: left;
		position: relative;
		cursor: pointer;
	}

	.company-list .box {
		float: left;
		background: rgba(255, 255, 255, 1);
		border: 1px solid rgba(220, 220, 220, 1);
		width: 274px;
		height: 207px;
		margin: 0px 33px 17px 0;
		padding: 0 8px;
	}

	.company-list::-webkit-scrollbar {
		width: 8px;
		height: 8px;
		background-color: #f5f7fa;
	}
	/*滚动条的轨道*/

	.company-list::-webkit-scrollbar-track {
		/*box-shadow: inset 0 0 5px rgba(0,0,0,.3);*/
		background-color: #fff;
	}
	/*滚动条的滑块按钮*/

	.company-list::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background-color: #D2D2D2;
		/*box-shadow: inset 0 0 5px #000;*/
		/*box-shadow: 8px 0 0 #A5ADB7 inset;*/
	}
	/*滚动条的上下两端的按钮*/

	.company-list::-webkit-scrollbar-button {
		height: 0;
		background-color: #fff;
	}

	.clearfix:after {
		content: "";
		display: block;
		clear: both;
	}

	.company-list {
		padding: 0px 0px 0 20px;
		height: calc(100% - 165px);
		overflow-y: auto;
		overflow-x: hidden;
		width: calc(100% - 20px);
		position: relative;
		top: 10px;
	}

	* {
		-webkit-touch-callout: none;
		/*系统默认菜单被禁用*/
		-webkit-user-select: none;
		/*webkit浏览器*/
		-khtml-user-select: none;
		/*早期浏览器*/
		-moz-user-select: none;
		/*火狐*/
		-ms-user-select: none;
		/*IE10*/
		user-select: none;
	}

	.dev_org {
		position: absolute;
		top: 36px;
		bottom: 0;
	}

	.ops_title {
		line-height: 55px;
		text-align: left;
		font-size: 16px;
		text-indent: 18px;
		color: #2c3e50;
	}

	#NoticeRule {
		margin-top: -16px;
	}

	.tabs-box {
		float: left;
		height: 40px;
		overflow: hidden;
		background-color: #fff;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		border: 1px solid #d2d2d2;
		/*border-bottom: 0;*/
		position: absolute;
		top: -43px;
		/*top: 1px;*/
	}

	.tabs-box div {
		float: left;
		padding: 9px 0;
		transition: .1s;
		cursor: pointer;
	}

	.tabs-box span {
		display: inline-block;
		width: 110px;
		font-size: 14px;
		line-height: 22px;
		border-left: 1px solid #e2e2e2;
		float: left;
	}

	.tabs-box>div:first-child span {
		border: none;
	}

	.list-box {
		position: absolute;
		top: 0;
		left: 328px;
		right: 0;
		bottom: 0;
	}

	.list-top {
		margin: 0px 16px 15px 16px;
		padding-top: 24px;
		height: 34px;
	}

	.add-btn {
		float: left;
		line-height: 32px !important;
		padding: 0 15px !important;
	}

	.search {
		float: right;
		width: 328px;
		margin-right: 10px;
	}

	.search-btn {
		float: right;
    margin-right: 15px;
	}

	.company-list {
		/*overflow: hidden;*/
		/*margin-bottom: 32px;*/
		height: 550px;
		max-height: 550px;
	}

	.scroll {
		overflow: auto;
		width: 97.6%;
		max-height: 550px !important;
    height: 550px;
		margin: 0 16px;
		box-sizing: border-box;
		border: 1px solid #f2f2f2;
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
	}

	/* .scroll>ul:last-child {
		border-bottom: 0;
	} */

	.list-title,
	.list-details {
		display: flex;
		justify-content: space-around;
		line-height: 44px;
		font-size: 14px;
		color: #636363;
	}

	.list-title {
		background: #eeeeee;
	}

	.list-title li,
	.list-details li {
		width: 200px;
		margin: 0 20px;
		text-align: left;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.list-details {
		border-top: 1px solid #f2f2f2;
	}

	.operate span {
		margin: 0 4px;
		color: #5087e4;
	}

	.w-18 {
		width: 18% !important;
	}

	.list-details:last-child {
		border-bottom: 1px solid #f2f2f2;
	}

	img.notes {
		position: relative;
		left: 5px;
		top: 5px;
	}
  .w-120 {
  	width: 140px !important;
  	margin-right: 20px !important;
  }
	.w-90 {
		width: 90px !important;
		margin-right: 40px !important;
	}

	.active {
		background: #5087e4;
		color: #fff;
	}

	.active>span {
		border: 0;
	}
	.bg {
		width: 100%;
	}
	/* 弹窗 */
	.popup>div {
		position: fixed;
		top: -50px;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 0 28px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		margin-left: -289px;
		width: 578px;
		background-color: #fff;
		z-index: 999;
		padding-bottom: 30px;
		height: 285px;
		text-align: left;
    margin: auto;
	}
  .popup-delAlarm{
    opacity: 0;
    display: none;
    transition: .2s;
  }
	.popup-title {
		font-size: 16px;
		line-height: 64px;
		border-bottom: 1px solid #e5e5e5;
		margin-bottom: 12px;
		text-align: left;
	}

	.popup-lab {
		font-size: 14px;
		line-height: 30px;
		margin-bottom: 14px;
	}

	.popup-btn-box {
		text-align: center;
		margin-top: 30px;
		position: absolute;
		width: 100%;
		left: 0;
		bottom: 38px;
	}

	.popup-btn-box .el-button {
		padding: 0 34px !important;
		line-height: 34px !important;
		margin: 0 20px;
	}
  .popup-add{
      min-width: 580px !important;
      height: 580px !important;
      margin-left: 0 !important;
      top: 50% !important;
      transform: translate(-30%,-30%);
  }
  .popup-left,.popup-right{
      width: 47%;
      float: left;
  }
  .popup-left{
      margin-right: 5%;
  }
  .popup-bottom{
    float: left;
    width: 100%;
  }
	.b-32 {
		position: absolute;
		bottom: 32px;
		left: 0;
	}

	i.close {
		font-size: 20px;
		float: right;
		margin-top: 24px;
	}

	img.notes {
		position: relative;
		left: 8px;
		top: 4px;
	}

	.b-32 {
		position: absolute;
		bottom: 32px;
		left: 0;
	}

	.btn-box {
		position: absolute;
		text-align: center;
		bottom: 36px;
		width: 100%;
		left: 0;
	}

	.btn-box .el-button {
		padding: 0 34px !important;
		line-height: 34px !important;
		margin: 0 20px;
	}
</style>
<style>
	#NoticeRule .popup .el-input__inner {
		line-height: 34px !important;
		height: 34px !important;
		padding: 0 10px !important;
	}

	#NoticeRule .popup .el-form-item {
		width: 100% !important;
		margin-bottom: 11px !important;
	}

	#NoticeRule .popup .el-form-item__label {
		padding: 0 !important;
		color: #2f3a4e !important;
		line-height: 14px !important;
		margin-top: 10px;
		margin-bottom: 5px;
	}

	#NoticeRule .popup .el-form-item__content {
		line-height: 34px !important;
	}

	#NoticeRule .search .el-icon-search {
		line-height: 34px !important;
	}

	#NoticeRule .popup .el-form-item.m-b-10 {
		margin-bottom: 10px !important;
	}

	#NoticeRule .popup .el-input__icon {
		line-height: 34px !important;
	}

	#NoticeRule .search .el-input__inner {
		line-height: 34px !important;
		height: 34px !important;
		padding: 0 10px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/BigScreen/Devops.vue